import { createReduxModule } from 'hooks-for-redux'
import { getSearchResults } from '../api/searchApi'
import { ISearchRequest, ISearchResultResponse } from '../api/searchApi.types'
import { StatusCodes } from "http-status-codes";

const initialState: ISearchResultResponse = {
    results: [],
    facets: { facets: [] },
    totalResults: 0,
    trackingId: ''
}

export const [useSearchResults, { setSearchResults }, searchStore] = createReduxModule(
    'searchResults', initialState, {
    // Reducers
    setSearchResults: (
        searchResults: ISearchResultResponse,
        partialSearchResults: ISearchResultResponse) =>
        ({ ...searchResults, ...partialSearchResults })
}
)

export const updateSearchResults = async (request: ISearchRequest) => {
    const result = await getSearchResults(request);
    if (result?.status !== StatusCodes.OK) return result?.status;

    setSearchResults(result.data);

    return StatusCodes.OK;
}

